/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { FieldsGroupFormField, FormFieldType } from '../typings';
import { setConditionalParentFields } from '../store';

export class FieldsGroupFormFieldBuilder extends BaseCompoundFormFieldBuilder<FieldsGroupFormField> {
  protected _type = FormFieldType.FieldsGroup;
  protected _typeValue = FormFieldType.FieldsGroup;
  // @ts-ignore
  private _fields: FieldsGroupFormField['fields'] = [];
  // @ts-ignore
  private _isCollapsible: FieldsGroupFormField['isCollapsible'] = false;
  // @ts-ignore
  private _isRequired?: FieldsGroupFormField['isRequired'] = false;
  // @ts-ignore
  private _restriction: FieldsGroupFormField['restriction'];
  // @ts-ignore
  private _address?: FieldsGroupFormField['address'];

  constructor() {
    super();
  }

  public address(value: FieldsGroupFormField['address']): this {
    this._address = value;

    return this;
  }

  public isCollapsible(value: FieldsGroupFormField['isCollapsible']): this {
    this._isCollapsible = value;

    return this;
  }

  public isRequired(value: FieldsGroupFormField['isRequired']): this {
    this._isRequired = value;

    return this;
  }

  public restriction(value: FieldsGroupFormField['restriction']): this {
    this._restriction = value;

    return this;
  }

  // TODO: Add method to add single field
  public fields(value: FieldsGroupFormField['fields']): this {
    this._fields = [...value];

    const childrenIds = this._fields.map(child => child.fieldId);

    const parentFields = { [this._fieldId]: childrenIds };

    store.dispatch(setConditionalParentFields(parentFields));

    return this;
  }
}
